module.exports = __webpack_public_path__ + "img/search.f275a990.png";